import { type User, userSchema } from '@/entities/user/types';
import { ENDPOINTS } from '@/shared/api/endpoints';
import { request } from '@/shared/api/request';

export async function getCurrentUser(): Promise<User> {
  const data = await request<unknown>({
    method: 'GET',
    url: ENDPOINTS.auth.me,
  });
  return userSchema.parse(data);
}
